<template>
  <div class="imgList">
    <img class="img01" :src=this.img_left.address>
    <img class="img02" :src=this.img_right.address>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                img_left: {},
                img_right:{}
            }
        },
        methods: {
            getImgList() {
                axios.get('/static/mock/produceInfo.json')
                    .then(this.getSucc);
            },

            getSucc(res) {
                res = res.data;
                const data = res.produceImg;
                this.img_left = data[0];
                this.img_right = data[1];
            },
        },
        mounted() {
            this.getImgList();
        },
    }
</script>

<style scoped>
  .imgList {
    width: 1130px;
    height: 620px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 0 8px #ffffff;
    margin: auto;
    padding: 50px 0 50px 8px;
  }

  .img01 {
    /*width: 50%;*/
    width: 700px;
    margin-top: 50px;
  }

  .img02 {
    width: 380px;
    margin-bottom: 75px;
    margin-left: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Technology/Components/produceAbility.vue